// extracted by mini-css-extract-plugin
export default {"container":"wrapper-desktop-page_container__OK6aa"};